export const PRODUCT_GROUP_SIZES = {
  grid: {
    sm: {
      breakpoint: 364,
      rowSize: 2,
      adPosition: 4,
    },
    md: {
      breakpoint: 536,
      rowSize: 3,
      adPosition: 6,
    },
    lg: {
      breakpoint: 868,
      rowSize: 4,
      adPosition: 8,
    },
    xl: {
      breakpoint: 960,
      rowSize: 3,
      adPosition: 6,
    },
    xxl: {
      breakpoint: 1105,
      rowSize: 4,
      adPosition: 8,
    },
  },
};

export const PRODUCT_GRID_TEST_ID = 'product-grid';
